import { isProjectionFormula, isProjectionIngredient, projectionBindingNames } from './formula';
import { segmentLengths, slopedSegmentLengths } from './lengths';
import { packSticks, packSticksDetailed, unservableSegments } from './pack';
import { makePackProjectedLineSegments } from './paved';
import {
	layoutLineSegmentsInArea,
	projectionToDrawingLines,
	projectLineSegmentsFromArea,
} from './project';

/**
 * Stud/joist projection engine: project framing lines into drawn areas at a
 * spacing and angle, clip them against cut-outs, and pack the pieces into the
 * selected materials' stock lengths.
 *
 * Design and decisions: PR #1859 ("FINAL DESIGN v1" + amendments). Acceptance
 * contract: `studProjectionFormula.spec.ts`, pinned against a real dev canvas.
 *
 * Pure TS over interval arithmetic — no polygon-clipping, no dependencies.
 * `segmentLengths` is the one unit-aware seam; everything else is unit-blind.
 */
export const projectionUtils = {
	isProjectionFormula,
	isProjectionIngredient,
	projectionBindingNames,
	projectLineSegmentsFromArea,
	layoutLineSegmentsInArea,
	projectionToDrawingLines,
	segmentLengths,
	slopedSegmentLengths,
	packSticks,
	packSticksDetailed,
	unservableSegments,
	makePackProjectedLineSegments,
};

export type { DrawingLine, LineLayout } from './project';
export type {
	PackCollector,
	PackEvent,
	PackedStick,
	PackMaterial,
	Projection,
	ProjectionCollector,
	ProjectionEvent,
	ProjectionLayer,
	ProjectionSegment,
} from './types';
